import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

const mobileSectionMsgCache = createLocalStorageProvider('issue-mobile-section-message');

export const getMobileSectionMsgCache = (cloudId: string): string | null =>
	mobileSectionMsgCache.get(`${cloudId}_mobile_section_message_is_dismissed`) || null;

export const setMobileSectionMsgCache = (cloudId: string, value: string): void =>
	mobileSectionMsgCache.set(`${cloudId}_mobile_section_message_is_dismissed`, value);
